<template>
  <div class="questionnaire">
    <Substrate v-if="activeQuestionId !== 0">
      <Question />
    </Substrate>
    <UserInfo v-else />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import Question from './components/Question';
import Substrate from './components/Substrate';
import UserInfo from './components/UserInfo';

export default {
  components: {
    Substrate,
    Question,
    UserInfo
  },
  computed: {
    ...mapState('auth', {
      userData: s => s.data.user,
      getUserData: s => s.meta.getUserData
    }),
    ...mapState('questionnaire', {
      activeQuestionId: s => s.data.activeQuestionId
    }),
    routeName() {
      return this.$route.name;
    }
  },
  mounted() {
    this.getUserInfo();

    this.$store.dispatch('questionnaire/getQuestionnaireList');
  },
  methods: {
    async getUserInfo() {
      if (!this.gettingUserInfo) {
        await this.$store.dispatch('auth/getUserInfo');
      }
      if (!this.userData.questionnaireAvailable) {
        this.$router.push({ name: 'courses' });
      }
    }
  }
};
</script>

<style>
html {
  overflow: auto;
}
</style>
